import request from "@/utils/request";
import {customRequest} from "@/api/custom/utils";

export const getDeptTree = customRequest('/dept/tree')
